import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  PaymentCardsListParams,
  PaymentCardsListResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const PAYMENT_CARDS_LIST_QUERY_KEY = 'payment_cards_list';

export const usePaymentCardsListQuery = (
  url: string,
  queryParams: PaymentCardsListParams['queryParams'],
) =>
  useQuery({
    queryKey: [PAYMENT_CARDS_LIST_QUERY_KEY, url, queryParams],
    queryFn: () =>
      HttpClient.request<PaymentCardsListResponseData>({
        method: 'GET',
        url,
        params: queryParams,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
